import { IRootState } from '../../../store'
import { IPatientMedicalHistoryOptionsState } from '../store/options.types'

export const getPatientMedicalHistoryOptionsSelector = (state: IRootState): IPatientMedicalHistoryOptionsState =>
  state.options.patientMedicalHistoryOptions
